import axios from 'axios';

const getUserName = async id => {
  return await axios.get(`https://api.opensea.io/api/v1/account/${id}`);
};

export { getUserName };
